if(typeof jQuery == 'undefined'){
var script = document.createElement('script');
script.type = "text/javascript";
script.src = "//ajax.googleapis.com/ajax/libs/jquery/1.11.0/jquery.min.js";
document.getElementsByTagName('head')[0].appendChild(script);
}

jQuery(document).ready(function($){
	var shop_name = Shopify.shop;
	var PATHTOAPP = 'https://ittechzilla.com/dev/languagepanda';
	
	$.getScript(PATHTOAPP+"/getstoreinfo.php?shop="+shop_name, function( data, textStatus, jqxhr ) {
		//console.log(PATHTOAPP+"/getstoreinfo.php?shop="+shop_name);
	if(language_onoff == 0){ //true

		if($("#google_translate_element").length){
			//$("#google_translate_element").addClass(language_style+' position_'+language_position);
			//$("#google_translate_element").append('<div class="panda-icon-btn"></div>');
		}else{
			$("head").before('<div id="google_translate_element" class="'+language_style+' position_'+language_position+'"><div class="panda-icon-btn"></div></div>');
		}

		$("head").append('<link rel="stylesheet" href="'+PATHTOAPP+'/dist/css/languagepanda-style.css" type="text/css" />');
		$("head").append('<script type="text/javascript" src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"></script>');

		if(language_style == 'style_1'){
			
			if(translatelang == 0){ //all language
				var __function = function googleTranslateElementInit() {
				new google.translate.TranslateElement({pageLanguage: primary_locale}, 'google_translate_element');
				}
			}else{
				var __function = function googleTranslateElementInit() {
				  new google.translate.TranslateElement({pageLanguage: primary_locale, includedLanguages: specific_languages, multilanguagePage: true}, 'google_translate_element');
				}
			}

		}else{
			
			if(translatelang == 0){ //all language
				var __function = function googleTranslateElementInit() {
				  new google.translate.TranslateElement({pageLanguage: primary_locale, layout: google.translate.TranslateElement.InlineLayout.SIMPLE}, 'google_translate_element');
				}
			}else{
				var __function = function googleTranslateElementInit() {
				  new google.translate.TranslateElement({pageLanguage: primary_locale, includedLanguages: specific_languages, multilanguagePage: true, layout: google.translate.TranslateElement.InlineLayout.SIMPLE}, 'google_translate_element');
				}
			}
		}

		var script = document.createElement("script");
		script.type="text/javascript";
		script.innerHTML= __function;
		document.getElementsByTagName('head')[0].appendChild(script);
	}
	});
});